import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { CustomFloatingFilterProps } from 'ag-grid-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const startAdornment = (
    <InputAdornment position="start">
        <SearchIcon fontSize="small" sx={{ color: 'muiBlack' }} />
    </InputAdornment>
);
const StyTextField = styled(TextField, {
    name: 'StyTextField',
})({
    '& .MuiInputBase-input': {
        fontSize: '12px',
        // maxHeight and width are necessary with 'flexDirection: row' and 'alignItems: center' when floatingButton is enabled
        maxHeight: '30px',
        width: '100%',
    },
    '& .MuiOutlinedInput-adornedStart': {
        paddingLeft: '6px',
    },
    '& .MuiInputAdornment-positionStart': {
        marginRight: '4px',
    },
    flexDirection: 'row',
    alignItems: 'center',
});

const TextFloatingFilter = ({
    model,
    onModelChange,
}: CustomFloatingFilterProps) => {
    const { t } = useTranslation();
    const onChange = ({
        target: { value: newValue },
    }: React.ChangeEvent<HTMLInputElement>) => {
        onModelChange(
            newValue === ''
                ? null
                : { ...(model || { type: 'contains' }), filter: newValue },
        );
    };
    return (
        <StyTextField
            value={model?.filter || ''}
            size="small"
            placeholder={t('common.searchPlaceholder')}
            InputProps={{
                startAdornment,
                disableInjectingGlobalStyles: true,
            }}
            onChange={onChange}
            variant="outlined"
        />
    );
};

export default TextFloatingFilter;
